import UIWatcher from './ui.watcher'

const Watcher = () => {
  return <UIWatcher />
}

export default Watcher
